  import { StandardEvents } from '@shopify/events';

  if (!customElements.get('blusvia-buy-now')) {
    customElements.define('blusvia-buy-now', class extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        this.button = this.querySelector('button');
        this.productForm = this.closest('product-form-component');
        if (!this.form || !this.button || !this.productForm) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.pending = false;
        this.submitting = false;
        this.selectionFailed = false;
        this.generation = 0;
        this.button.addEventListener('click', () => this.checkout(), { signal });
        window.addEventListener('pageshow', () => {
          this.submitting = false;
          this.button.removeAttribute('aria-busy');
          this.syncButton();
        }, { signal });
        const section = this.closest('.shopify-section');
        section?.addEventListener(StandardEvents.productSelect, async (event) => {
          if (event.target.closest('product-card')) return;
          const generation = ++this.generation;
          this.pending = true;
          this.syncButton();
          try {
            const result = await event.promise;
            if (generation !== this.generation) return;
            this.selectionFailed = !result?.detail?.html || !result?.detail?.resource?.available;
          } catch {
            if (generation === this.generation) this.selectionFailed = true;
          } finally {
            if (generation === this.generation) {
              this.pending = false;
              queueMicrotask(() => this.syncButton());
            }
          }
        }, { signal });
        const nativeButton = this.form.querySelector('add-to-cart-component');
        this.observer = new MutationObserver(() => this.syncButton());
        if (nativeButton) this.observer.observe(nativeButton, {
          attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true
        });
        this.syncButton();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }

      syncButton() {
        const nativeButton = this.form.querySelector('add-to-cart-component button');
        this.button.disabled = this.pending || this.submitting || this.selectionFailed ||
          !nativeButton || nativeButton.disabled || !this.form.elements.namedItem('id')?.value;
      }

      checkout() {
        this.syncButton();
        if (this.button.disabled || !this.form.reportValidity()) return;
        const quantitySelector = this.productForm.querySelector('quantity-selector-component');
        if (quantitySelector?.canAddToCart && !quantitySelector.canAddToCart().canAdd) return;

        // A separate native POST preserves existing cart lines and the original AJAX add-to-cart form.
        const checkoutForm = document.createElement('form');
        checkoutForm.method = 'post';
        checkoutForm.action = this.form.action;
        checkoutForm.hidden = true;
        const data = new FormData(this.form);
        data.set('return_to', this.dataset.checkoutUrl);
        for (const [name, value] of data) {
          if (typeof value !== 'string') continue;
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          checkoutForm.append(input);
        }
        document.body.append(checkoutForm);
        this.submitting = true;
        this.button.setAttribute('aria-busy', 'true');
        this.syncButton();
        HTMLFormElement.prototype.submit.call(checkoutForm);
        checkoutForm.remove();
      }
    });
  }
